import React from 'react'
import { StyledMenu } from './BurgerMenu.styled'

import { Link } from 'gatsby'

import styles from './BurgerMenu.module.css'

const BurgerMenu = ({ open }) => {
  return (
    <StyledMenu className={styles.burgerMenu} open={open}>
      <Link exact to="/" activeClassName={styles.active}>
        Home
      </Link>
      <Link exact to="/about" activeClassName={styles.active}>
        About
      </Link>
      <Link exact to="/products" activeClassName={styles.active}>
        Products
      </Link>
      <Link exact to="/contact" activeClassName={styles.active}>
        Contact
      </Link>
    </StyledMenu>
  )
}
export default BurgerMenu
